import {
    Check,
    Delete,
    Description,
    East,
    Edit,
    PersonRemove,
    Unarchive,
} from '@mui/icons-material';
import {
    Box,
    Button,
    Chip,
    Container,
    Divider,
    Grid, IconButton,
    Paper,
    Popover,
    styled, Tooltip,
    Typography,
    useTheme,
} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {RootState} from '../../../store';
import notificationDelete from '../../../shared/notificationDelete';
import {
    projectComplete,
    projectDelete,
    projectExportExcel,
    projectGet,
    projectGetDetail,
    projectMoveToActive,
} from '../project.api';
import {useCallback, useEffect, useState} from 'react';
import hot from '../../../assets/images/hot.png';
import Pagination from '../../../shared/Pagination';
import {
    addProjectDetailList,
    removeProjectDetailList, resetProjectDetailList,
    setDataExpandedList,
    setParameterGetData, setProjectLoading
} from '../project.reducer';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

import {
    DataGrid,
    GridActionsCellItem,
    GridColDef,
    GridCsvExportOptions,
    GridPagination,
    GridRowId,
    GridRowsProp,
    GridToolbar,
    GridToolbarContainer,
    GridToolbarExport,
    useGridApiContext,

} from '@mui/x-data-grid';
import {
    DataGridPro,
    DataGridProProps,
    FilterColumnsArgs,
    GetColumnForNewFilterArgs,
    getGridStringOperators,
    GridFilterInputValueProps,
    GridFilterOperator,
    GRID_DETAIL_PANEL_TOGGLE_COL_DEF,

} from '@mui/x-data-grid-pro';
import {IconChevronDown, IconChevronUp} from '@tabler/icons-react';
import {InterfaceProjectData, InterfaceProjectDetail, InterfaceProjectDetailFielding} from '../project.interface';
import StaticLoading from "../../../shared/StaticLoading";
import { baseUrl } from '../../../state';

interface PaginationModel {
    page: number;
    pageSize: number;
}

const StyledDataGrid = styled(DataGridPro)(({theme}) => ({
    border: 0,
    color: 'rgba(255,255,255,0.85)',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '& .MuiDataGrid-columnsContainer': {
        backgroundColor: '#1d1d1d',
        ...theme.applyStyles('light', {
            backgroundColor: '#fafafa',
        }),
    },
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
        borderRight: '1px solid #303030',
        ...theme.applyStyles('light', {
            borderRightColor: '#f0f0f0',
        }),
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: '1px solid #303030',
        ...theme.applyStyles('light', {
            borderBottomColor: '#f0f0f0',
        }),
    },
    '& .MuiDataGrid-cell': {
        color: 'rgba(255,255,255,0.65)',
        ...theme.applyStyles('light', {
            color: 'rgba(0,0,0,.85)',
        }),
    },
    '& .MuiPaginationItem-root': {
        borderRadius: 0,
    },
    ...theme.applyStyles('light', {
        color: 'rgba(0,0,0,.85)',
    }),
}));

function CustomExpandIcon() {
    return <IconChevronDown size={18}/>;
}

function CustomCollapseIcon() {
    return <IconChevronUp size={18}/>;
}

interface DetailTableProps {
    row?: InterfaceProjectData;
    rows?: any[];
}

const DetailTable = ({row = {} as InterfaceProjectData, rows = []}: DetailTableProps) => {

    const navigate = useNavigate();

    const {
        projectDetailList,
    } = useSelector((state: RootState) => state.project)


    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);


    const columns: GridColDef[] = [
        {
            field: 'fieldingRequest', headerName: 'Req Number', flex: 1, sortable: false,
            filterable: false,
        },
        {
            field: 'fieldingType',
            headerName: 'Fielding Type',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (data) => {
                return (
                    <>
                        {data.row.fieldingRequestMarkers
                            ?.map((marker: any) => {
                                return {
                                    customTypeString: marker.customTypeString,
                                    requestedFielding: parseInt(marker.requestedFielding)
                                }
                            })
                            .reduce((acc: {
                                customTypeString: string,
                                requestedFielding: number
                            }[], current: {
                                customTypeString: string,
                                requestedFielding: number
                            }) => {
                                const x: { customTypeString: string, requestedFielding: number } | undefined = acc.find(
                                    (item: {
                                        customTypeString: string,
                                        requestedFielding: number
                                    }) => item.customTypeString === current.customTypeString
                                )
                                if (x !== undefined) {
                                    x.requestedFielding += current.requestedFielding
                                    return acc
                                }
                                return acc.concat([current])
                            }, [])
                            ?.map((value: {
                                customTypeString: string,
                                requestedFielding: number
                            }) => (
                                <div
                                    style={{
                                        display: "flex",
                                        minWidth: "130px",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <p
                                        style={{
                                            display: "flex",
                                            width: "80px",
                                            justifyContent: "space-between",
                                            margin: 0
                                        }}
                                    >
                                        <span>{value.customTypeString}</span>
                                    </p>
                                    <p
                                        style={{
                                            display: "flex",
                                            width: "50px",
                                            justifyContent: "space-between",
                                            margin: 0
                                        }}
                                    >
                                        <span>: </span> <span>{value.requestedFielding}</span>
                                    </p>

                                </div>
                            ))}
                    </>
                )

            }
        },
        {
            field: 'dueDateString',
            headerName: 'Due Date',
            flex: 1,
            sortable: false,
            filterable: false,
        },
        {
            field: 'modifiedDateString',
            headerName: 'Last Update',
            flex: 1,
            sortable: false,
            filterable: false,
        },
        {
            field: 'fielderNames',
            headerName: 'Fielder',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (data) => {
                let fielderNamesObj = data.row.fielderNames?.map((item: string) => {
                    // get item text before text 'Assigned'
                    let assignedIndex = item.indexOf('Assigned')
                    if (assignedIndex !== -1) {
                        return {
                            fielder: item.substring(0, assignedIndex - 1),
                            assigned: item.substring(assignedIndex)
                        }
                    }
                })

                return <div style={{
                    height: 'inherit',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}>
                    {
                        fielderNamesObj.map((item: any) => {
                            return (
                                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                    <Typography onMouseEnter={handlePopoverOpen}
                                                onMouseLeave={handlePopoverClose} sx={{cursor: 'default'}} fontSize={11}
                                                color={'#093a93'} mr={1}>{item.fielder}</Typography>
                                    <Popover
                                        className="custom-popover"
                                        sx={{
                                            pointerEvents: 'none',
                                            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
                                            padding: 2
                                        }}
                                        open={open}
                                        anchorEl={anchorEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        onClose={handlePopoverClose}
                                        disableRestoreFocus
                                    >
                                        <Typography fontSize={11}> {item.assigned}</Typography>
                                    </Popover>
                                </div>
                            )
                        })
                    }
                </div>

            }
        },
        {
            field: 'lastAssignDateString',
            headerName: 'Assign Date',
            sortable: false,
            filterable: false,
            flex: 1,
        },
        {
            field: 'claimDateString',
            headerName: 'Claim Date',
            sortable: false,
            filterable: false,
            flex: 1,
        },
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            minWidth: 200,
            getActions: ({id}) => {
                // check index from id
                console.log(id)
                console.log(projectDetailList.find((item) => item.id === row.id))
                let index = projectDetailList.find((item) => item.id === row.id)?.projectFieldingRequests?.findIndex((item) => item.fieldingRequestId === id)
                return [
                    // <GridActionsCellItem component={IconButton}
                    //                      icon={<EditIcon sx={{fontSize: '1.3rem', color: '#757575'}}/>}
                    //                      onClick={() => navigate(`/project/detail/fieldrequest?projectid=${detail.id}&index=${index}`)} label="Edit"/>,
                    // <GridActionsCellItem component={IconButton}
                    //                      icon={<AddCircleOutlineIcon sx={{fontSize: '1.3rem', color: '#757575'}}/>}
                    //                      onClick={() => navigate(`/project/assign?id=${id}`)} label="Assign"/>,
                    <Button color={'success'}
                            onClick={() => navigate(`/project/detail/fieldrequest?projectid=${row.id}&index=${index === -1 ? 0 : index}`)}
                            startIcon={<EditIcon sx={{fontSize: '1.3rem'}}/>}>
                        Edit
                    </Button>,
                    <Button onClick={() => navigate(`/project/assign?id=${id}`)}
                            startIcon={<AddCircleOutlineIcon sx={{fontSize: '1.3rem'}}/>}>
                        Assign
                    </Button>
                ];
            }
        }
    ];

    return (
        <div style={{height: 'auto', width: '100%', border: '1px solid #f0f0f0'}}>
            <StyledDataGrid
                rows={projectDetailList.find((item) => item.id === row.id)?.projectFieldingRequests?.map((item) => {
                    return {
                        ...item,
                        id: item.fieldingRequestId,
                    }
                }) ?? []} columns={columns} hideFooter/>
        </div>
    );
};

const getDetailPanelContent = (row: any) => {
    return (
        <Box sx={{p: 2}}>
            <DetailTable row={row}/>
        </Box>)
};

const getDetailPanelHeight: DataGridProProps['getDetailPanelHeight'] = () =>
    'auto';

export default function ProjectSheet(props: {
    onSelect: (projectId: string) => void;
}) {
    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch<any>();

    const {dataList, dataTotal, parameterGetData, projectDetailList} = useSelector(
        (state: RootState) => state.project
    );

    const rows: GridRowsProp = [
        {id: 1, col1: 'Hello', col2: 'World'},
        {id: 2, col1: 'DataGridPro', col2: 'is Awesome'},
        {id: 3, col1: 'MUI', col2: 'is Amazing'},
    ];

    const [isLoading, setIsLoading] = useState(false)

    function CustomDetailPanelHeader() {

        const expandOrCollapseAll = () => {
            setIsLoading(true)
            if (projectDetailList.length === 0) {
                const responsePromise = dataList.map(item => {
                    return dispatch(projectGetDetail(item.id))
                        .unwrap()
                        .then(async (response: any) => {
                            dispatch(
                                addProjectDetailList([
                                    response.data.data
                                ])
                            )
                            return {
                                success: true
                            }
                        })
                        .catch(() => {
                            return {
                                success: false
                            }
                        })
                })

                Promise.all(responsePromise).then((response) => {
                    setIsLoading(false)
                })
            } else {
                dispatch(resetProjectDetailList())
                setIsLoading(false)
            }
        };

        const Icon = projectDetailList.length === 0 ? UnfoldMoreIcon : UnfoldLessIcon;

        return (
            <Tooltip title={'Expand All'}>
                <IconButton
                    size="small"
                    tabIndex={-1}
                    onClick={expandOrCollapseAll}
                    aria-label={'Expand All'}
                >
                    <Icon fontSize="inherit"/>
                </IconButton>
            </Tooltip>
        );
    }

    const columns: GridColDef[] = [
        {
            ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
            renderHeader: () => <CustomDetailPanelHeader/>,
        },
        {field: 'projectNumber', headerName: 'Project', flex: 1, filterable: false},
        {
            field: 'customerCodeString',
            headerName: 'Project Customer Code',
            flex: 1,
            filterable: false
        },
        {
            field: 'totalMarkerRequest',
            headerName: 'Total Requested',
            flex: 1,
            filterable: false
        },
        {field: 'dueDateString', headerName: 'Due Date', flex: 1, filterable: false},
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            getActions: ({id}) => {
                return [
                    <Button color={'success'} onClick={() => navigate(
                        `/project/detail?id=${id}`
                    )} startIcon={<EditIcon sx={{fontSize: '1.3rem'}}/>}>
                        Edit
                    </Button>,
                    // <GridActionsCellItem component={IconButton}
                    //                      icon={<EditIcon sx={{fontSize: '1.3rem', color: '#757575'}}/>}
                    //                      onClick={() => navigate(
                    //                          `/project/detail?id=${id}`
                    //                      )} label="Edit"/>,
                    // <GridActionsCellItem component={IconButton}
                    //                      icon={<CancelIcon sx={{ fontSize: '1.3rem', color: '#757575' }} />}
                    //                      onClick={() => console.log(id)} label="Delete" />
                ];
            }
        }
    ];

    useEffect(() => {
        dispatch(resetProjectDetailList())
        dispatch(
            setParameterGetData({
                ...parameterGetData,
                sortField: '',
                sortType: 0,
            })
        );
        // eslint-disable-next-line
    }, [dispatch]);

    useEffect(() => {
        dispatch(projectGet(parameterGetData));
    }, [dispatch, parameterGetData]);

    const handleDelete = (id: string) => {
        notificationDelete().then((isConfirmed) => {
            if (isConfirmed) {
                dispatch(projectDelete(id))
                    .unwrap()
                    .then(() => {
                        dispatch(projectGet(parameterGetData));
                    });
            }
        });
    };

    const handleToActive = (projectId: string) => {
        dispatch(projectMoveToActive(projectId))
            .unwrap()
            .then(() => {
                dispatch(projectGet(parameterGetData));
            });
    };

    const handleComplete = (projectId: string) => {
        dispatch(projectComplete(projectId))
            .unwrap()
            .then(() => {
                dispatch(projectGet(parameterGetData));
            });
    };

    const handlePaginationModelChange = (paginationModel: PaginationModel) => {
        console.log(paginationModel);
        dispatch(
            setParameterGetData({
                ...parameterGetData,
                skip: paginationModel.page * paginationModel.pageSize,
                take: paginationModel.pageSize,
            })
        );
    };

    const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState<
        GridRowId[]
    >([]);

    const handleDetailPanelExpandedRowIdsChange = useCallback(
        (newIds: GridRowId[]) => {
            // get the differences between projectDetailList.id and newIds
            let newIdsFiltered = projectDetailList.filter((item: any) => {
                return newIds.findIndex((id) => id === item.id) === -1
            })

            // check if each newIds is not in each projectDetailList
            let isExist = newIds.every((item: any) => {
                return projectDetailList.findIndex((project) => project.id === item) !== -1
            })

            if (isExist) {
                dispatch(
                    removeProjectDetailList(newIdsFiltered[0]?.id)
                )
            } else {
                dispatch(projectGetDetail(newIds.length > 1 ? [newIds[newIds.length - 1]][0] as string : newIds[0] as string))
                    .unwrap()
                    .then(async (response: any) => {
                        let data: InterfaceProjectDetail = response.data.data
                        // dispatch(
                        //     setDataExpandedList([
                        //         response.data.data
                        //     ])
                        // )
                        dispatch(
                            addProjectDetailList([
                                response.data.data
                            ])
                        )
                        // fillAddress(data)
                    })
            }


            // setDetailPanelExpandedRowIds(
            //     newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds
            // );
        },
        [projectDetailList]
    );




    function CustomToolbar() {

    const [isExporting, setisExporting] = useState(false)

      const handleExport = () => {
        setisExporting(true)
        dispatch(projectExportExcel(parameterGetData))
        .unwrap()
        .then((res: any) => {
            let arr = res.data.data;
            const downloadLink = document.createElement('a');
            downloadLink.href = baseUrl + "/" + res.data.data
            downloadLink.setAttribute('download', arr[arr.length - 1]);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
        }).catch((err: any) => {
            console.log(err)
        })
        .finally(() => {
            setisExporting(false)
        })
      }

        const buttonBaseProps = {
    color: 'primary',
    size: 'small',
    startIcon: <Description/>,

  } as const;
      
        return (
            <GridToolbarContainer>
                    <Button {...buttonBaseProps} disabled={isExporting}  onClick={() => handleExport()}> {isExporting ? "Exporting, Please Wait..." : "Export to Excel"}</Button>
                <GridPagination />
            </GridToolbarContainer>
        );
    }

    return (
        <Container
            maxWidth={'xl'}
            sx={{
                marginY: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
            }}
        >
            <StaticLoading isLoading={isLoading}/>
            <div style={{borderRadius: 20, backgroundColor: '#ffffff'}}>
                <div style={{height: '70vh', width: '100%'}}>
                    <StyledDataGrid
                        rows={dataList}
                        columns={columns}
                        rowCount={dataTotal}
                        pagination
                        paginationMode="server"
                        onPaginationModelChange={handlePaginationModelChange}
                        getDetailPanelContent={({row}) => {
                            return getDetailPanelContent(row)
                        }}
                        getDetailPanelHeight={getDetailPanelHeight}
                        detailPanelExpandedRowIds={
                            projectDetailList.map(item => item.id)
                        }
                        onDetailPanelExpandedRowIdsChange={
                            handleDetailPanelExpandedRowIdsChange
                        }
                        slots={{
                            detailPanelExpandIcon: CustomExpandIcon,
                            detailPanelCollapseIcon: CustomCollapseIcon,
                            footer: CustomToolbar,
                        }}
                    />
                </div>
            </div>
        </Container>
    );
}
